module.exports = __webpack_public_path__ + "static/media/marcoGeneral.b7463bf3.pdf";